import {
    MarketResearchCompensationData,
    MarketResearchDiversityData,
    MarketResearchSummaryData,
    MarketResearchSupplyDemandData,
    RelodeApiError,
} from "@relode/core";
import {
    ActionsUnion,
    createAction,
} from "@relode/core/components/reducer/actionHelpers";

import { JobPublicDetails } from "../../../../shared/types";

export enum names {
    LOAD_JOB = "LOAD_JOB",
    LOAD_JOB_SUCCESS = "LOAD_JOB_SUCCESS",
    LOAD_JOB_FAILURE = "LOAD_JOB_FAILURE",

    MARKET_RESEARCH_COMPENSATION = "MARKET_RESEARCH_COMPENSATION",
    MARKET_RESEARCH_COMPENSATION_SUCCESS = "MARKET_RESEARCH_COMPENSATION_SUCCESS",
    MARKET_RESEARCH_COMPENSATION_FAILURE = "MARKET_RESEARCH_COMPENSATION_FAILURE",

    MARKET_RESEARCH_SUPPLY_DEMAND = "MARKET_RESEARCH_SUPPLY_DEMAND",
    MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS = "MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS",
    MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE = "MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE",

    MARKET_RESEARCH_DIVERSITY = "MARKET_RESEARCH_DIVERSITY",
    MARKET_RESEARCH_DIVERSITY_SUCCESS = "MARKET_RESEARCH_DIVERSITY_SUCCESS",
    MARKET_RESEARCH_DIVERSITY_FAILURE = "MARKET_RESEARCH_DIVERSITY_FAILURE",

    MARKET_RESEARCH_SUMMARY = "MARKET_RESEARCH_SUMMARY",
    MARKET_RESEARCH_SUMMARY_SUCCESS = "MARKET_RESEARCH_SUMMARY_SUCCESS",
    MARKET_RESEARCH_SUMMARY_FAILURE = "MARKET_RESEARCH_SUMMARY_FAILURE",
}

export const creators = {
    loadJob: () => createAction(names.LOAD_JOB),
    loadJobSuccess: (job: JobPublicDetails, token: string) =>
        createAction(names.LOAD_JOB_SUCCESS, { job, token }),
    loadJobFailure: (error: RelodeApiError) =>
        createAction(names.LOAD_JOB_FAILURE, { error }),

    loadMarketResearchCompensation: () =>
        createAction(names.MARKET_RESEARCH_COMPENSATION),
    loadMarketResearchCompensationSuccess: (
        data: MarketResearchCompensationData
    ) => createAction(names.MARKET_RESEARCH_COMPENSATION_SUCCESS, { data }),
    loadMarketResearchCompensationFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_COMPENSATION_FAILURE, { error }),

    loadMarketResearchSupplyDemand: () =>
        createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND),
    loadMarketResearchSupplyDemandSuccess: (
        data: MarketResearchSupplyDemandData
    ) => createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND_SUCCESS, { data }),
    loadMarketResearchSupplyDemandFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_SUPPLY_DEMAND_FAILURE, { error }),

    loadMarketResearchDiversity: () =>
        createAction(names.MARKET_RESEARCH_DIVERSITY),
    loadMarketResearchDiversitySuccess: (data: MarketResearchDiversityData) =>
        createAction(names.MARKET_RESEARCH_DIVERSITY_SUCCESS, { data }),
    loadMarketResearchDiversityFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_DIVERSITY_FAILURE, { error }),

    loadMarketResearchSummary: () =>
        createAction(names.MARKET_RESEARCH_SUMMARY),
    loadMarketResearchSummarySuccess: (summary: MarketResearchSummaryData) =>
        createAction(names.MARKET_RESEARCH_SUMMARY_SUCCESS, { summary }),
    loadMarketResearchSummaryFailure: (error: RelodeApiError) =>
        createAction(names.MARKET_RESEARCH_SUMMARY_FAILURE, { error }),
};

export type ClientPublicJobActionTypes = ActionsUnion<typeof creators>;
